import { adminCall, adminGet } from '../../api/adminCall';

export const fetchContactSubmissions = async () => {
  return adminGet('/api/admin/contact-submissions');
};

export const updateContactSubmissionStatus = async ({ submissionId, status }) => {
  return adminCall(
    `/api/admin/contact-submissions/${encodeURIComponent(submissionId)}/status`,
    { status }
  );
};

export const addContactSubmissionNote = async ({ submissionId, text }) => {
  return adminCall(
    `/api/admin/contact-submissions/${encodeURIComponent(submissionId)}/notes`,
    { text }
  );
};
